import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const AddEditModal = ({isOpen, onClose, onSave,message }) => {
  const [roles, setroles] = useState();
  const handleSave = () => {
      onSave(roles);
  };
  
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
    <ModalHeader toggle={onClose}>
        Add Role
      </ModalHeader>
      <ModalBody>
        <div className="form-group">
          <label>Role:</label>
          <input
            type="text"
            className="form-control"
            onChange={(e) => setroles(e.target.value.toUpperCase())}
          />
        </div>  
        {message && <div className="text-danger">{message}</div>}     
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
        <Button color="primary" onClick={handleSave}>
          Add
        </Button>
       
      </ModalFooter>
    </Modal>
  );
};

export default AddEditModal;
